import { EvidencesTypeEnum, EvidencesTypeValueEnum } from "../enums/evidences";

const transformEvidences: Record<EvidencesTypeEnum, EvidencesTypeValueEnum> = {
  [EvidencesTypeEnum.CAMERA]: EvidencesTypeValueEnum.CAMERA,
  [EvidencesTypeEnum.COMMENT]: EvidencesTypeValueEnum.COMMENT,
  [EvidencesTypeEnum.FILE]: EvidencesTypeValueEnum.DOCUMENT,
  [EvidencesTypeEnum.IMAGE]: EvidencesTypeValueEnum.IMAGE,
  [EvidencesTypeEnum.SIGN]: EvidencesTypeValueEnum.SIGN,
  [EvidencesTypeEnum.VIDEO]: EvidencesTypeValueEnum.VIDEO,
  [EvidencesTypeEnum.VIDEO_GALLERY]: EvidencesTypeValueEnum.VIDEO_GALLERY,
  [EvidencesTypeEnum.OBSERVATION_COMMENT]: EvidencesTypeValueEnum.OBSERVATION_COMMENT,
}


const transformEvidencesNumber: Record<EvidencesTypeValueEnum, EvidencesTypeEnum> = {
  [EvidencesTypeValueEnum.CAMERA]: EvidencesTypeEnum.CAMERA,
  [EvidencesTypeValueEnum.COMMENT]: EvidencesTypeEnum.COMMENT,
  [EvidencesTypeValueEnum.OBSERVATION_COMMENT]: EvidencesTypeEnum.OBSERVATION_COMMENT,
  [EvidencesTypeValueEnum.DOCUMENT]: EvidencesTypeEnum.FILE,
  [EvidencesTypeValueEnum.IMAGE]: EvidencesTypeEnum.IMAGE,
  [EvidencesTypeValueEnum.SIGN]: EvidencesTypeEnum.SIGN,
  [EvidencesTypeValueEnum.VIDEO]: EvidencesTypeEnum.VIDEO,
  [EvidencesTypeValueEnum.VIDEO_GALLERY]: EvidencesTypeEnum.VIDEO_GALLERY,
}
const transformPluralsEvidencesNumber: Record<EvidencesTypeValueEnum, string> = {
  [EvidencesTypeValueEnum.CAMERA]: 'images',
  [EvidencesTypeValueEnum.IMAGE]: 'images',
  [EvidencesTypeValueEnum.SIGN]: 'sign',
  [EvidencesTypeValueEnum.COMMENT]: 'comments',
  [EvidencesTypeValueEnum.OBSERVATION_COMMENT]: 'comments',
  [EvidencesTypeValueEnum.DOCUMENT]: 'documents',
  [EvidencesTypeValueEnum.VIDEO]: 'video',
  [EvidencesTypeValueEnum.VIDEO_GALLERY]: 'video',
}
export { transformEvidences, transformEvidencesNumber, transformPluralsEvidencesNumber }